
import { PuttSituation } from "@/types/golf";

export const midDistanceApproaches: PuttSituation = {
  id: 14,
  name: "Approches mi-distance",
  image: "/lovable-uploads/2095b9e8-2d0a-4fe1-aedd-c4376b3a4d7f.png",
  description: "Sur le green d'approche ou sur le parcours choisissez un trou et matérialisez la position de départ de cette situation de jeu. Placer une marque au point H=20m disposée entre le bord du green et un trou à 10 m minimum du bord de green. Jouez ensuite 10 balles.",
  distances: [
    { point: "H", distance: 20, ballCount: 10 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 4 },
    { condition: "Balle à moins de 1m", points: 2 },
    { condition: "Balle entre 1m et 2m", points: 1 },
    { condition: "Balle au-delà de 2m", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 39 },
    { points: 1, index: 36 },
    { points: 2, index: 33 },
    { points: 3, index: 29 },
    { points: 4, index: 25 },
    { points: 5, index: 21 },
    { points: 6, index: 18 },
    { points: 7, index: 15 },
    { points: 8, index: 12 },
    { points: 9, index: 9 },
    { points: 10, index: 6 },
    { points: 11, index: 4 },
    { points: 12, index: 2 },
    { points: 13, index: 0 },
    { points: 14, index: -2 },
    { points: 15, index: -4 },
    { points: 16, index: -5 },
    { points: 17, index: -6 },
    { points: 18, index: -7 },
    { points: 19, index: -8 },
  ],
};
